module.exports = __webpack_public_path__ + "static/media/Mk logo.918ac2c9.jpg";